import { Component, Input } from '@angular/core';
import { formDefinition } from '../evaluation-forms';
import {
  APPRAISAL_MONTHS,
  EvaluationField,
  EvaluationScore,
  fieldsFor,
  formTypeLabel,
  scoreSummary
} from '../evaluation.model';

@Component({
  selector: 'app-evaluation-form',
  templateUrl: './evaluation-form.component.html',
  styleUrls: ['./evaluation-form.component.css'],
  standalone: false
})
export class EvaluationFormComponent {

  @Input() formType: string | null = null;
  @Input() answers: Record<string, string | number | null> = {};
  @Input() viewOnly = false;
  @Input() staffName = '';
  @Input() year: number | null = null;
  @Input() quarter: number | null = null;
  @Input() status = '';

  readonly months = APPRAISAL_MONTHS;

  get formLabel(): string {
    return formTypeLabel(this.formType);
  }

  get scale() {
    return formDefinition(this.formType)?.scale ?? [];
  }

  get legend() {
    return formDefinition(this.formType)?.legend ?? [];
  }

  get score(): EvaluationScore {
    return scoreSummary(this.formType, this.answers);
  }

  get groupedFields(): { section: string; fields: EvaluationField[] }[] {
    const order: string[] = [];
    const groups = new Map<string, EvaluationField[]>();

    for (const field of fieldsFor(this.formType)) {
      const section = field.section || 'Questions';
      if (!groups.has(section)) {
        order.push(section);
        groups.set(section, []);
      }
      groups.get(section)?.push(field);
    }

    return order.map(section => ({
      section,
      fields: groups.get(section) ?? []
    }));
  }

  monthActive(index: number): boolean {
    if (!this.quarter) {
      return false;
    }
    const start = (this.quarter - 1) * 3;
    return index >= start && index < start + 3;
  }

  isSelected(field: EvaluationField, value: string | number): boolean {
    return Number(this.answers[field.key]) === Number(value);
  }

  setRating(key: string, score: number): void {
    if (this.viewOnly) {
      return;
    }
    this.answers[key] = score;
  }
}
